<div class="m-3 gap-2 d-flex flex-column justify-content-between">
  <div class="pb-2">
    <app-text-field
      label="{{ 'name_column' | translate }}"
      [formControl]="createColumnForm.controls.name"
      [error]="createColumnForm.controls.name.status === 'INVALID' && createColumnForm.controls.name.touched"
    >
    </app-text-field>

    @if (
      createColumnForm.controls.name.status === 'INVALID' &&
      (createColumnForm.controls.name.dirty || createColumnForm.controls.name.touched)
    ) {
      <mat-hint class="text-danger" style="font-size: 12px"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
    }
  </div>

  <div class="pb-2">
    <app-text-field
      label="{{ 'name_color' | translate }}"
      type="color"
      [formControl]="createColumnForm.controls.text_color"
    >
    </app-text-field>
  </div>

  <div class="pb-2">
    <app-text-field
      label="{{ 'column_color' | translate }}"
      type="color"
      [formControl]="createColumnForm.controls.bg_color"
    >
    </app-text-field>
  </div>

  <mat-divider></mat-divider>

  <div class="d-flex justify-content-end" mat-dialog-actions>
    <app-button [customClass]="'bg-danger'" (onChangeClick)="onCancelClick()" [btnType]="'cancel'">
      <span>
        {{ 'cancel' | translate }}
      </span>
    </app-button>

    <app-button
      class="btn-submit ms-2"
      (onChangeClick)="onSaveClick()"
      [disabled]="(column && !hasChange) || createColumnForm.invalid"
    >
      {{ 'save' | translate }}
    </app-button>
  </div>
</div>
